import React from "react";
import { Modal, Button } from "react-bootstrap";
import Icon from "../sub/Icon";
import Roles from "../../enums/Roles";
import "./ChangelogModal.css";

class ChangelogModal extends React.Component {
  renderClientContent() {
    return (
      <div className="changelog-content">
        <div className="feature-item mb-4">
          <div className="d-flex align-items-start mb-2">
            <div
              className="feature-icon me-3"
              style={{
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                color: "white",
                width: "50px",
                height: "50px",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "1.5rem",
                marginRight: "1rem",
                flexShrink: 0,
              }}
            >
              🔑
            </div>
            <div>
              <h5 className="mb-2">Nouvelle rubrique Locations</h5>
              <p className="text-muted mb-2">
                Vous pouvez désormais effectuer des{" "}
                <strong>demandes de location</strong> de matériel médical
                directement depuis la plateforme.
              </p>
              <p className="text-muted mb-0">
                Rendez-vous dans la rubrique <strong>"Locations"</strong> pour
                découvrir cette nouvelle fonctionnalité et soumettre vos
                demandes en quelques clics.
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderAdminContent() {
    return (
      <div className="changelog-content">
        <div className="feature-item mb-4">
          <div className="d-flex align-items-start mb-2">
            <div
              className="feature-icon me-3"
              style={{
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                color: "white",
                width: "50px",
                height: "50px",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "1.5rem",
                marginRight: "1rem",
                flexShrink: 0,
              }}
            >
              🏷️
            </div>
            <div>
              <h5 className="mb-2">Impression d'etiquettes plastifiees sur imprimante DYMO</h5>
              <p className="text-muted mb-2">
                Vous pouvez desormais exporter les codes-barres de votre parc au{" "}
                <strong>format CSV</strong> pour les imprimer sur une imprimante
                d'etiquettes DYMO.
              </p>
              <p className="text-muted mb-0">
                Rendez-vous dans la rubrique <strong>"Parc"</strong>, selectionnez
                un etablissement, puis cliquez sur{" "}
                <strong>"Imprimer les codes barre du parc"</strong> et choisissez
                le format CSV.
              </p>
            </div>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "1rem",
          }}
        >
          <iframe
            width="100%"
            height="400"
            src="https://www.youtube.com/embed/v6e3_XiRmM0"
            title="Tutoriel video - Impression etiquettes DYMO"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            style={{
              border: "none",
              borderRadius: "8px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
              maxWidth: "720px",
            }}
          ></iframe>
        </div>
      </div>
    );
  }

  render() {
    const { show, onClose, userRole } = this.props;
    const isClient = userRole === Roles.CLIENT;

    return (
      <Modal
        show={show}
        onHide={onClose}
        size="xl"
        centered
        backdrop="static"
        keyboard={false}
        className="changelog-modal"
      >
        <Modal.Header
          className="text-center"
          style={{
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            color: "white",
            border: "none",
          }}
        >
          <Modal.Title className="d-flex align-items-center">
            <Icon icon="star" className="me-2 mr-2" />
            Nouvelle fonctionnalité
          </Modal.Title>
        </Modal.Header>

        <Modal.Body
          style={{
            maxHeight: "60vh",
            overflowY: "auto",
            padding: "2rem",
          }}
        >
          <div className="mb-3">
            <p className="text-muted">
              Découvrez la dernière nouveauté de votre plateforme PEPSiCOLL :
            </p>
          </div>

          {isClient ? this.renderClientContent() : this.renderAdminContent()}
        </Modal.Body>

        <Modal.Footer
          style={{
            background: "#f8f9fa",
            border: "none",
            padding: "1.5rem 2rem",
          }}
        >
          <Button
            variant="primary"
            onClick={onClose}
            style={{
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              border: "none",
              padding: "0.75rem 2rem",
              borderRadius: "10px",
              fontWeight: "600",
            }}
          >
            <Icon icon="check" className="me-2" />
            J'ai compris
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default ChangelogModal;
